module.exports = __webpack_public_path__ + "img/bul_arr_bottom_gray.5d386db4.svg";